//#region redux
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
import { updateInvoiceActivationState } from "store/actions/authActions";
//#endregion
//#region types
import { IconDefinitionConstants, InvoiceConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import ActivateInvoiceFormContainer from "./../forms/activate/activateFormContainer";
import { useLocation, useNavigate } from "react-router-dom";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

function useActivateInvoiceCreationDialog() {
  const dispatch = useDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const onActivationSuccess = () => {
    dispatch(displayDialog(getWaitingForActivationDialog()));
    dispatch(updateInvoiceActivationState(WintSuperkollAPIModel.InvoiceActivationState.WaitingForActivation));
  };

  const onActivationRequestError = (values?: any, closeDialog?: () => void) => {
    if (values?.codes?.length) {
      switch (values.codes[0]) {
        case InvoiceConstants.InvoicesActicationInProgressErrorCode:
          onActivationSuccess();
          closeDialog && closeDialog();
          return;
        case InvoiceConstants.InvoicesAlreadyActivatedErrorCode:
          dispatch(updateInvoiceActivationState(WintSuperkollAPIModel.InvoiceActivationState.Activated));
          closeDialog && closeDialog();
          navigate(UrlHelper.formatPath(`/Invoice/Create`), {
            state: {
              background: location,
            },
          });
          return;
      }
    }
  };

  const getActivateInvoiceCreationDialog = (): DialogProps => {
    return {
      isOpen: false,
      id: "invoiceActivationForm",
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.EnableCustomerInvoicing),
      titleIcon: IconDefinitionConstants.WSend,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Submit),
        },
      ],
      dialogType: DialogEnums.DialogType.Content,
      children: <ActivateInvoiceFormContainer />,
      maxWidth: "sm",
      onSubmit: onActivationSuccess,
      onError: onActivationRequestError,
      customCloseConfirmation: {
        title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.FormExitWarningMessage2),
        content: LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Invoice.ActivationFormExitWarningDescription
        ),
      },
    };
  };

  const getWaitingForActivationDialog = (): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.InvoiceWaitingActivationTitle),
      titleIcon: IconDefinitionConstants.WSend,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.OK),
        },
      ],
      dialogType: DialogEnums.DialogType.Message,
      children: LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Invoice.InvoiceWaitingActivationDescription
      ),
      hideCancelButton: true,
      maxWidth: "sm",
    };
  };

  return { getActivateInvoiceCreationDialog, getWaitingForActivationDialog };
}

export default useActivateInvoiceCreationDialog;
